// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PurchaseOrderPickUpLine } from './purchase-order-pick-up-line';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PurchaseOrderPickUp extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  completed?: Date;
  completedBy?: string;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  instructions?: string;
  notes?: string;
  numberOfSkids?: string;
  scheduledDate!: Date;
  totalWeight?: string;
  lines!: PurchaseOrderPickUpLine[];
}

